import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import FileUpload from "../components/FileUpload";

import useToken from '../hooks/useToken';
import { SERVER_API_URL } from '../config/Constants'
import ViewProject from './ViewProject';
import ProjectUtils from '../utils/projectUtils'
import { BrowserRouter, Route, Switch, useRouteMatch, Link } from 'react-router-dom';
import ProjectService from "../services/ProjectService";
import Image from "../components/Image"
import ImageBackground from "../components/ImageBackground"
import { HEADER_HEIGHT } from '../config/Constants'
import Button from "../components/Button"
import Utils from "../utils/utils";
import { SECONDARY_COLOR } from "../config/styles";
import strings from "../config/strings";
import "../config/styles.css"
import { CopyToClipboard } from 'react-copy-to-clipboard';

import {
  ScrollView,
  View,
  TextInput,
  Text,
  TouchableOpacity,
  StyleSheet,
  Platform,
  Alert,
  FlatList,
  ActivityIndicator,
  Dimensions,
  Picker
} from 'react-native';
import Game from "./Game";



const BUTTON_COLOR = "#2A8286"


function GameResult(props) {
  const { type } = useParams();

  let history = useHistory();
  let location = window.location;
  const [picUrl, setPicUrl] = useState(null);
  const [title, setTitle] = useState(null);
  const [text, setText] = useState(null);
  const [copied, setCopied] = useState(false);

  const width = Dimensions.get("window").width;
  const height = Dimensions.get("window").height;

  const isMobile = width < 768;
  const isTablet = width >= 768 && width < 1024;
  const picWidth = isMobile ? ((width * 0.9) - 48) : ((width * 0.8) - 92) / 2;

  console.log("GameResult picWidth", picWidth);
    const boldText = (text) => {
    return <Text style={{ fontSize: 16, fontWeight: 600 }}>{text}</Text>
  }
const ALL_RESULTS = {
  craftclub: {
    title: "The Craft Club",
    text: `You show up that Tuesday, unsure what to expect. But by the time the kettle whistles and someone’s passing around homemade stitch markers like candy, you know you’re staying.
The group is everything: loud, opinionated, endlessly generous. There are heated debates over the best cast-on method, passionate speeches about sock yarn durability, and one member who insists /bold/swatching is a government conspiracy/bold/. You love them all.
You become a regular: The one who always brings banana bread and weird yarns. Not every project turns out. You once knit an entire hat that was somehow both too small and too large. But no one judges. They just laugh and help you frog it.
Eventually, you learn the truth: the mystery yarn came from a local shop doing a clever promotional stunt. No ancient curse, no hidden society. Just really good marketing.
But you don’t mind. /bold/The real magic wasn’t in the skein, it was in finding your people./bold/
Every Tuesday night, as the needles click and the tea steeps, you’re exactly where you belong.`
  },
  theorist: {
    title: "The Stitch Theorist",
    text: `You never submitted a revision. You didn’t chase a degree. You chased something real, something the institutions weren’t ready to understand.
You set up your own fiber lab in a converted garden shed. The floorboards are full of pins and tea stains. The walls are covered in yarn-behavior charts, tension diagrams, and cryptic notes written in permanent marker. A skein once tangled itself into what looked like a Möbius loop. You took it as a sign.
You talk to almost no one… except a small, fervent online group who refers to you only as “the Stitch Theorist.” They trade field notes, blurry photos of questionable fiber phenomena, and links to essays by someone known only as “the yarn philosopher” — though no one agrees whether that’s a person, a concept, or a really well-written chatbot.
People call you “eccentric,” “non-peer-reviewed,” and “alarmingly correct.”
You don’t mind.
After all, the yarn never asked for credentials. It just wanted to be understood.`
  },
  scholar: {
    title: "The Fiber Scholar",
    text: `What began as a side obsession evolved into formal research — testing fiber under controlled conditions, tracing historical mentions, and writing a thesis titled: /bold/Narrative Structure in Non-Repeating Motifs./bold/
Now, you lecture at the Institute of /bold/Applied Fiber Arts/bold/, where classroom debates about stitch tension regularly get applause.
You organize fieldwork trips to Icelandic sheep farms, peer-review obscure stitch manuscripts, and mentor the next generation of fiber theorists.
The original skein that started it all now rests in a climate-controlled glass case outside your office, labeled simply:
“Specimen 001: The Yarn That Unraveled Everything.”`
  },
  philosopher: {
    title: "The Fiber-Philosopher",
    text: `You didn’t want to tame the fiber. You wanted to understand it, to /bold/really engage with it/bold/.
    So you listened. Watched how it moved, how it twisted under tension, how it resisted being defined. And slowly, it began to reveal things. Not just about fiber, but about everything.
    The world. Time. The nature of choice. /bold/Why swatches always lie/bold/.
You asked it questions.
It responded in knots and loops, in dropped stitches that felt intentional, in tension shifts that mirrored your own uncertainty.
Now, you're not just crafting — you're interpreting.
You’re the Fiber Philosopher:
Writing abstract parables like /bold/The Paradox of the Tangled Skein/bold/.
Debating in obscure forum threads with alarming intensity.
Publishing books with titles like “Ply: A Theory of Everything” and “Through the Loop, Eternally.” Some call it nonsense. Others call it enlightenment with a gauge swatch. /bold/You call it purpose./bold/\nYou're not here to finish projects.
You're here to follow the thread, /bold/wherever it leads/bold/.`,
  },
  evercoze: {
    title: "The cloak of evercoze",
    text: `You finished the cloak, slipped it on, and instantly felt it, a quiet hum of energy beneath the stitches. The warmth was just the beginning.
With the cloak wrapped around your shoulders, your tools transformed. Crochet hooks curved to your will. Needles flicked with precision no pattern could teach. In your hands, they weren’t just tools, they were wands. Instruments of fiber magic.
Swatches knit themselves in perfect gauge. Charts revealed hidden meanings. You once fixed a lace mistake three rows down using only the power of intent and a slightly threatening whisper.
Blocking wires bowed with reverence. Skeins unraveled smoothly, knots melting before you. Yarn ends detached themselves with a crisp little snip when dismissed. You never asked for this power but the yarn chose you.
Daily life? Not that different. You still misplace your tape measure. Still own too many tote bags. Your cat still ignores your greatness. But in the crafting world?
You’re a living legend.
Rumors swirl from Ravelry forums to local yarn shops about the witch with the warming cloak. Secret Discord threads call you She Who Casts at Midnight. No one really knows where you came from, just that your tension is perfect, and your magic is strong when you are wearing the cloak.`,
  },
  empire: {
    title: "Building a heated empire",
    text: `It started with a mystery yarn, a radiating stich, a single blanket and a dream.
That dream? Napping… professionally.
You launched /bold/Threadiators Inc./bold/ and your flagship product, The Nap Trap Blanket, hit the market like a weighted comfort bomb. Self-heating, cat-attracting, emotionally stabilizing. It sold out before you even finished knitting the second prototype.
Soon, you were filthy rich. Blanket-on-a-private-island rich. I-have-a-room-just-for-buttons rich. My cat has a personal assistant who only brushes him rich.
Soon you had to expand and built The Threadquarters: a multi-story corporate temple complete with a rooftop sheep pasture and underground yarn vault. You give TED talks titled "Disrupting Warmth" and /bold/Forbes put you on their 30 Under 30 Blanket Barons list/bold/, and Business Insider did a full spread on your gold-plated yarn bowl.
But… something’s not quite right. At night, the yarn scraps whisper.
Sometimes you catch a glimpse of your original skein (the one from the mystery box) peeking out of sealed storage, slightly pulsing. One time, you were alone in your penthouse loom room, a rogue stitch appeared in your knitting, one you didn’t cast on. It looks suspiciously like… a warning.
You tell yourself it’s just stress.
But maybe, just maybe, you weren’t supposed to monetize the ancient yarn of unknowable warmth.
Maybe The Nap Trap was never meant to be weaponized for naps.
You’re fabulously wealthy. And slightly cursed.
But that’s just showbiz, baby.`,
  },
    hopecrafter: {
    title: "The hopecrafter",
    text: `Sure, you could have sold out. Built a wooly empire. But no, you chose compassion over capitalism. Warmth over wealth. Also, spreadsheets give you hives.
You launched /bold/Blankets Without Borders/bold/, an initiative delivering self-warming blankets to those who need them most. It began modestly: one donation drop-off at a local shelter. Then a chilly community center. Then a snowed-in alpaca farm that refused to evacuate until everyone had thermal capes.
Now, your magical blankets are everywhere.
Lining benches in train stations. Wrapped around protestors. Warming penguin handlers. Distributed in bulk to college students whose landlords swear the heating works.
Your daily life is wonderfully chaotic. You run a team of rogue knitters, organize emergency “wrap-a-thons,” and frequently ship warm cargo across oceans, time zones, and once, somehow, into a treehouse commune in rural Vermont.
Slowly your initiative is turning into a worldwide movement:
Disaster zones? Covered. Cold bus stops? Toasty.
Libraries where the heating budget was last updated in 1997? Radiant.
The office where Brian from accounting controls the thermostat? Justice at last.
At the end of each day, you curl up under that very first magical blanket, the prototype that started it all, still humming faintly with cozy purpose.
Because while the world is still cold in many ways, /bold/you’ve made a lot of it warmer/bold/.`,
  },
      stitchonaut: {
    title: "The Stitchonaut",
    text: `You dove into the yarn implosion like a hero in a high-stakes space opera… if that hero wore fuzzy socks and shouted “NOT MY MERINO!” mid-leap.
Next thing you knew: zero gravity. Neon skeins floating around you. Gauge swatches orbiting your head. You’ve been launched into /bold/the Yarniverse/bold/: a tangled, glitter-infused dimension powered by unfinished projects and cosmic tension.
Now you drift between floating yarn clusters and abandoned WIPs the size of small planets. You float from satellite stitch stations to rogue asteroid sock clusters, offering counsel to stranded crafters, untangling warp fields, and occasionally knitting black holes shut.
Your official title is /bold/Stitchonaut Supreme/bold/, but the locals just call you /bold/"Commander of the Cosmic Skein"/bold/.
Do you miss Earth? Sometimes.
Do you miss being able to find your scissors? Always.
This isn’t the life you planned but let’s be honest: the mystery yarn always had… potential.`,
  },
        chaos: {
    title: "The Chaotic Crafter",
    text: `You didn’t even try to sort it.
The moment you stood up and saw yarn cascading off the bookshelves, your half-knit sleeve tangled around a desk lamp, and what might’ve been a stitch marker embedded in a houseplant, you made a decision:
This is fine. This is art.
From that moment on, you stopped following patterns altogether. You stitched your way through the chaos like a fiber-fueled tornado with a dream.
You crochet with reckless abandon and knit with vibes only.
The mystery yarn? Lost to the tangle.
But something else unraveled in its place, your new, gloriously unhinged /bold/creative freedom/bold/.`,
  },
  order: {
    title: "New Precision",
    text: `The cleanup took days. Possibly weeks. You frogged what could be frogged, rewound what wasn’t fused with glitter, and exorcised at least one haunted skein.
The mystery yarn? Gone. Vanished. Possibly combusted.
But you learned from it. Never again would you start without checking yardage, gauge, and emotional stability. Now, you follow patterns to the letter. Your project notes are pristine. You block with mathematical precision.
Sometimes, you catch yourself staring at a wild tangle, wondering what might’ve been.
Then you shudder slightly… and go calculate your skeins according to pattern.`,
  },
    yarnfluencer: {
    title: "Going viral",
    text: `You didn’t expect much when you posted your first blurry WIP shot with the caption: “Attempting a shawl. May also be summoning a weather system.”
A few likes. Some intrigued comments but then someone shared it. And someone else… And then /bold/KnitTok/bold/ found it.
Slowly, steadily, the Ghost Purl began haunting social media. You started posting updates, chaotic, unfiltered, oddly poetic:
“Row 57: Dropped a stitch. It disappeared into the void. I let it go.”
“Row 72: Lost control. Stitch markers revolted. I respect their choices.”
You weren’t just knitting anymore, you were storytelling. Followers poured in and soon enough, brands reached out.
When you finally revealed the finished shawl, it went full viral. Your comment section is filled with praise, commissions, and memes.
/bold/Tom Daley/bold/ slides into your DMs asking for the pattern, says he wants to knit it between dives at the next Olympics. /bold/Taylor Swift/bold/’s stylist messaged, she wants to wear it on her next tour.
You have merch and your own ghost-purl emoji. You are now officially a /bold/yarnfluencer/bold/.`,
  },
      quiet: {
    title: "The Quiet Stitcher",
    text: `You kept the project to yourself because something about it felt… personal. Like the stitch had chosen you, and not the other way around.
You finished the shawl, blocked it with care, and folded it neatly in your drawer. On colder days, it rests on your shoulders like a /bold/secret/bold/. When people ask about it at knit nights, yarn shops, or during suspiciously long elevator rides, you smile and say:
“Oh, that? Just something I made once.”
The questions keep coming, of course and rumors spread between your fiber friends.
You don’t confirm. You don’t deny.
Your life stays mostly the same. Quiet evenings. Endless WIPs. A cat that refuses to sit anywhere but the shawl. But now there’s a whisper of mystery around you and a warmth you carry that /bold/no-one can quite explain/bold/.
You didn’t share the pattern. You kept the /bold/magic/bold/.`,
  },
  designer: {
    title: "Becoming a Pattern Designer",
    text: `You hit “publish” …and the crafting world loses its collective mind.
Within days, /bold/The Wispwalker climbs to the top of pattern charts/bold/. Ghost Purls begin to haunt shawls, sweaters, mittens, even one ambitious cloak worn exclusively for dramatic exits.
Yarn companies reach out to collaborate. You get your own curated mystery yarn box called /bold/The Whisper Skein/bold/. A popular knitting and crochet app (My Row Counter) wants secure exclusive rights to your next pattern release, available only to their app users. Workshops sell out and forums light up. People tag you in their WIPs with captions like “finally nailed the Ghost Purl — I think?”.
Your daily life as a renown Pattern Designer is still grounded in yarn but now you toggle between tester calls and tension swatches, promo reels and peaceful frogging. It’s busy and beautiful and exactly right.`,
  },
    threadkeeper: {
    title: "The Threadkeeper",
    text: `You step away, from the buzz, the branding, the endless meetings and the group chats.
So you unplug, pour some tea, place the self-heating blanket on your lap and feel a sense of calm you haven’t felt in far too long.
You start stitching again, a blanket for a friend, a shawl for your neighbor, a tiny, questionably-shaped hat for your cat (immediately rejected, as tradition demands).
And as you stitch, /bold/the warmth returns/bold/. not just in the yarn, but in the making. The quiet rhythm of needle and breath.
You don’t lead but somehow, /bold/your quiet joy spreads anyway/bold/.
And honestly?
That feels like more than enough.`,
  },
      stitchwitch: {
    title: "The Stitchwitch",
    text: `You finished the cloak, slipped it on, and instantly felt it, a quiet hum of energy beneath the stitches. The warmth was just the beginning.
With the cloak wrapped around your shoulders, your tools transformed. Crochet hooks curved to your will. Needles flicked with precision no pattern could teach. In your hands, they weren’t just tools, they were wands.
You never asked for this power but /bold/the yarn chose you/bold/.
Daily life? Not that different. You still misplace your tape measure. Still own too many tote bags. Your cat still ignores your greatness. But in the crafting world? You’re a living legend.
No one really knows where you came from, just that /bold/your tension is perfect/bold/, and your magic is strong when you are wearing the cloak.`,
  },
    threadling: {
    title: "The Threadling",
    text: `You wind skeins in silence. You swatch and un-swatch. You prepare tea for rituals you can’t yet attend. You copy patterns by hand, correcting errors in the margins with quiet satisfaction. You are trusted with tools, but not the Pattern Codex. You are permitted to ask questions, though not always to receive answers.
Some elders forget your name. Others remember every stitch. A few ask what you see and hear. /bold/You’ve seen more than they think/bold/.
There is a dignity in the quiet work of the apprentice. In showing up. In stitching without credit. In watching everything.
And when the time comes, when the yarn begins to shift again, when threads loosen and re-twist, /bold/you'll be ready/bold/.`,
  },
    lostloop: {
    title: "The one that slipped the stitch",
    text: `You said no. Too soon, /bold/too strange/bold/, too tangled. You weren’t looking for love, just answers. Maybe a little closure. Maybe a cult.
They smiled, nodded, said “Of course, totally get it.” …And never messaged again.
You never solved the mystery of the yarn but started going to fiber festivals, partly for distraction, partly on the off-chance you'd spot CableKnitCrush92.
Sometimes you think you do: A glimpse of a hooded cardigan. A flash of a “Knit Happens” tote.
But it’s always someone else.
People ask what happened with that mystery project you were so obsessed with.
You say, “Oh… I frogged it.” But what you mean is: it unraveled me first.
Love, like a good lace pattern, requires courage. And maybe just /bold/one more row/bold/.`,
  },
      love: {
    title: "Love at First Stitch (Well, Almost)",
    text: `You say yes. For yarn science, and maybe because CableKnitCrush92 has smile lines that suggest /bold/they’ve laughed at many fiber fails/bold/ and never judged a single one.
When they dig through their stash and finally pull out the skein they mentioned, it is nothing like your mystery yarn.
“Okay,” they say, “it looked more mysterious under my closet light.”
You both start laughing, and the evening shifts. The yarn talk fades but the sympathy doesn’t, and you stay the night.
In the morning, the yarn still doesn’t match — /bold/but maybe you do/bold/.
And while the mystery skein never revealed its secrets, something better did: a future of craft fairs shared and tangled projects tackled together. The mystery yarn didn’t lead to answers, but it led to /bold/someone who never minds sharing the good scissors/bold/.`,
  },
    stitchmaster: {
    title: "The Grand Stitchmaster",
    text: `The Circle spoke: not loudly, not suddenly, but in silence and certainty. One by one, the stitch markers dropped into the Grand Basket. All aligned. All agreed. /bold/You were chosen/bold/.
And that’s how you rose through the Circle not by improvisation, but by devotion — to order, tradition, and the quiet rigor of perfect tension. You showed your skill, honored every rule, never skipped a swatch, earned the respect of elders, and finally became The Grand Stitchmaster.
Your days begin before sunrise with tea, swatch inspection, and silence. Most fear asking your opinion. A few seek it like a blessing. All respect it. /bold/The Circle follows your lead/bold/. Patterns are submitted for your approval. You set the meeting themes. You decide who joins next.
The Thread Circle doesn’t advertise. It recruits. Quietly. Selectively.
If you receive an invitation, bring your best needles, your boldest WIP, and the humility to frog it in front of legends.`,
  },
second: {
    title: "Stitchmaster of the Second Circle",
    text: `You completed the Rite not to defy the Circle, but to fulfill something that had long been unfolding in your hands. To finish the pattern that had begun with the mystery Skein. You unraveled your earliest project because /bold/the yarn still had more to teach you/bold/.
Some elders were angered: not at your skill, but at your refusal to wait for the vote. Choices that led you here were sometimes bold, yes. But always made with one goal in mind: to keep the heart of the tradition alive and to pursue true mastery.
Now, /bold/you lead the Second Circle consisting of the others/bold/, those whose respect you’d earned stitch by stitch. It is smaller, more focused, and /bold/fiercely dedicated/bold/. You’ve kept the ancient customs (the fiber blessings, the solstice shawlings, the initiation) but added new ones, too.
You are the Stitchmaster now. Not by vote, but by presence.`,
  },
}


  useEffect(() => {

    // assign pic url depending on url parameter ?type=...
    //const searchParams = new URLSearchParams(location.search);
    //const type = searchParams.get('type');
    if (type) {
      setPicUrl(`/imgs/game_results/${type}.png`);
      setTitle(ALL_RESULTS[type].title);
      setText(ALL_RESULTS[type].text);
    }
  }
    , [location]);

  useEffect(() => {

    // assign pic url depending on url parameter ?type=...
    //const searchParams = new URLSearchParams(location.search);
    //const type = searchParams.get('type');
    if (copied) {
      alert("URL copied to clipboard! Share it with your friends to find out where the game has brought them!");
      setCopied(false);
    }
  }
    , [copied]);


  console.log("TestResult useEffect type", type);

  const pinkText = (text) => {
    return <Text style={{ fontSize: 16, color: "#EA423D", fontWeight: 600 }}>{text}</Text>
  }

  const renderResultParagraph = (line, index) => {
    var boldSplitted = line.split("/bold/");
    if (boldSplitted.length > 1) {
      return (
        <p
          key={index}
          style={{
            color: 'black',
            opacity: 0.8,
            fontSize: 16,
            fontWeight: 'normal',
            textAlign: 'left',
            letterSpacing: 2,
            padding: 0,
            paddingLeft: isMobile ? 0 : 12,
            marginVertical: 4,
          }}>
          {boldSplitted.map((part, i) => {
            if (i % 2 === 0) {
              return part; // regular text
            } else {
              return <span key={i} style={{ fontWeight: 'bold' }}>{part}</span>; // bold text
            }
          })}
        </p>
      )
    }
    return (
      <p
              key={index}
              style={{
                    color: 'black',
                    opacity: 0.8,
                    fontSize: 16,
                    fontWeight: 'normal',
                    textAlign: 'left',
                    letterSpacing: 2,
                    padding: 0,
                    paddingLeft: isMobile ? 0 : 12,
                    marginVertical: 4,
                }}>{line}</p>
    )
  }


  const renderDlBtn = (img, txt, link) => {
    return (
      <a className="testBtn" href={link} target="_blank">
        <View
          style={{
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            margin: 12,
            backgroundColor: "white",
            paddingHorizontal: 24,
            paddingVertical: 12,
            borderRadius: 24,
          }}>
          <Image
            urlOnServer={img}
            style={{
              width: 24,
              height: 24,
              marginRight: 12,
              tintColor: BUTTON_COLOR,
              opacity: 0.8
            }} />

          <p style={{
            color: BUTTON_COLOR,
            opacity: 0.6,
            fontSize: 14,
            fontWeight: 800,
            letterSpacing: 2,
            margin: 0,
          }}>{txt}</p>
        </View>
      </a>
    )
  }

  return (
    <ImageBackground
      id="GameResultContainer"
      urlOnServer={picUrl}
      style={{ width: Dimensions.get("window").width, height: Dimensions.get("window").height, justifyContent: 'center', alignItems: 'center' }}
    >
      <View style={{ backgroundColor: 'rgba(0,0,0,0.5)', position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }} />
      <ScrollView contentContainerStyle={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: Dimensions.get("window").width
      }}>

        <View style={{
          display: 'flex',
          flexDirection: isMobile ? "column" : 'row',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 24,
          borderRadius: 24,
          backgroundColor: 'rgba(255,255,255,0.8)',
          margin: isMobile ? 0 : 24,
          width: isMobile ? "100%" : '80%',
        }}>
          <Image urlOnServer={picUrl} style={{
            width: picWidth,
            height: picWidth * 1.4, // isMobile ? picWidth : picWidth / 1.5,
            marginRight: isMobile ? 0 : 12,
            borderRadius: 12,
          }} />
          <View style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            width: isMobile ? '90%' : '50%',
        }}>
          <h1 style={{
                color: "#F69503",
                opacity: 0.8,
                fontSize: isMobile ? 24 : 42,
                fontWeight: 'bold',
                textAlign: 'left',
                letterSpacing: 2,
                padding: 0,
                margin: 0,
                marginTop: isMobile ? 18 : 0,
                paddingLeft: isMobile ? 0 : 12,
                paddingBottom: 8,
            }}>{title}</h1>
          {
              text && text.split("\n").map((line, index) => {
                console.log("GameResult line", line);
                return renderResultParagraph(line, index)
              })}
          </View>


        </View>

        <View style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 24,
          borderRadius: 24,
          backgroundColor: 'rgba(255,255,255,0.8)',
          margin: isMobile ? 0 : 24,
          marginTop: isMobile ? 24 : 0,
          width: isMobile ? "100%" : '80%',
        }}>
          <h5 style={{
            color: "#F69503",
            opacity: 0.8,
            fontSize: isMobile ? 24 : 28,
            fontWeight: 'bold',
            textAlign: 'left',
            letterSpacing: 2,
            padding: 0,
            margin: 0,
            marginTop: isMobile ? 18 : 0,
            paddingLeft: isMobile ? 0 : 12,
            paddingBottom: 8,
          }}>Share your Yarnventure, win a 100$ voucher!</h5>
          <p style={{
            color: 'black',
            fontSize: 16,
            fontWeight: 'normal',
            letterSpacing: 2,
            padding: 0,
            margin: 0,
          }}>Liked your little Yarnventure? 🙂<br />
            Download the picture above and share it on {pinkText("Instagram")}, tagged with {pinkText("#MyYarnVenture")} for a chance to win a {pinkText("100$ crafting voucher!")}*
          </p>
          <a className="testBtn" href={picUrl} download>
            <View style={{
              backgroundColor: BUTTON_COLOR,
              paddingHorizontal: 24,
              paddingVertical: 12,
              borderRadius: 24,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: 12,

            }}>
              <p
                className="testBtnTxt"
                style={{
                  color: 'white',
                  fontSize: 16,
                  fontWeight: 'bold',
                  letterSpacing: 2,
                  padding: 0,
                  margin: 0,
                }}
              >Download image</p>
            </View>
          </a>

        </View>
        <View style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 24,
          borderRadius: 24,
          backgroundColor: 'rgba(255,255,255,0.8)',
          margin: isMobile ? 0 : 24,
          marginTop: isMobile ? 24 : 0,
          width: isMobile ? "100%" : '80%',
        }}>
          <p style={{
            color: 'black',
            fontSize: 16,
            fontWeight: 'normal',
            letterSpacing: 2,
            padding: 0,
            margin: 0,
          }}>Want to know where your crafter friends lend? Invite them into their own {pinkText("Yarnventure")}! </p>
          <p style={{
            color: 'black',
            opacity: 0.6,
            fontSize: 16,
            fontWeight: 'normal',
            letterSpacing: 2,
            padding: 0,
            margin: 0,
            marginTop: 12,
            marginBottom: 12,
          }}><b>URL:</b> <span style={{ fontStyle: "italic", textWrap: "wrap"}}>web.rowcounterapp.com/game/magical-yarn-story.html</span></p>
          <CopyToClipboard text={"https://web.rowcounterapp.com/game/magical-yarn-story.html"}
            onCopy={() => setCopied(true)}>
            <div id="copyUrlBtn">
              <View
                style={{
                  backgroundColor: BUTTON_COLOR,
                  paddingHorizontal: 24,
                  paddingVertical: 12,
                  borderRadius: 24,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 12,

                }}>
                <p
                  className="testBtnTxt"
                  style={{
                    color: 'white',
                    fontSize: 16,
                    fontWeight: 'bold',
                    letterSpacing: 2,
                    padding: 0,
                    margin: 0,
                  }}
                >Copy URL & Share</p>
              </View>
            </div>
          </CopyToClipboard>
          <p style={{
            color: 'black',
            fontSize: 16,
            fontWeight: 'normal',
            letterSpacing: 2,
            padding: 0,
            margin: 0,
            marginTop: 24,
          }}>Are you bold enough to jump on another journey? </p>
                    <a className="testBtn" href={"/yarnventure"} >
              <View
                style={{
                  backgroundColor: "white",
                  paddingHorizontal: 24,
                  paddingVertical: 12,
                  borderRadius: 24,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 12,

                }}>
                <p
                  className="testBtnTxt"
                  style={{
                    color: BUTTON_COLOR,
                    fontSize: 16,
                    fontWeight: 'bold',
                    letterSpacing: 2,
                    padding: 0,
                    margin: 0,
                  }}
                >Play again</p>
              </View>
              </a>
        </View>
                {/* <View style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 24,
          borderRadius: 24,
          backgroundColor: 'rgba(255,255,255,0.8)',
          margin: isMobile ? 0 : 24,
          marginTop: isMobile ? 24 : 0,
          width: isMobile ? "100%" : '80%',
        }}>
          <p style={{
            color: 'black',
            fontSize: 16,
            fontWeight: 'normal',
            letterSpacing: 2,
            padding: 0,
            margin: 0,
          }}>Bold enough to jump on another {pinkText("Yarnventure")}? </p>
          <a className="testBtn" href={"/yarnventure"} >
              <View
                style={{
                  backgroundColor: BUTTON_COLOR,
                  paddingHorizontal: 24,
                  paddingVertical: 12,
                  borderRadius: 24,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 12,

                }}>
                <p
                  className="testBtnTxt"
                  style={{
                    color: 'white',
                    fontSize: 16,
                    fontWeight: 'bold',
                    letterSpacing: 2,
                    padding: 0,
                    margin: 0,
                  }}
                >Play again</p>
              </View>
              </a>


        </View> */}
        <View style={{
          display: 'flex',
          flexDirection: isMobile ? "column" : 'row',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 24,
          borderRadius: 24,
          backgroundColor: "#FFE1BB", //'#FFEEB3',
          margin: isMobile ? 0 : 24,
          marginTop: isMobile ? 24 : 0,
          width: isMobile ? "100%" : '80%',
        }}>
          <Image urlOnServer={"/logo512.png"} style={{
            width: picWidth / 6,
            height: picWidth / 6,
            marginRight: isMobile ? 0 : 12,
          }} />
          <View
            style={{
              flex: 1,

            }}>
            <h1 style={{
              color: BUTTON_COLOR,
              opacity: 0.8,
              fontSize: 24,
              fontWeight: 'bold',
              textAlign: 'left',
              letterSpacing: 2,
              padding: 0,
              fontSize: 24,
              margin: 0,
              marginTop: isMobile ? 18 : 0,
              paddingLeft: isMobile ? 0 : 12,
              paddingBottom: 8,
            }}>Discover My Row Counter App</h1>
            <p style={{
              color: 'black',
              opacity: 0.8,
              fontSize: 14,
              fontWeight: 'normal',
              letterSpacing: 2,
              padding: 0,
              paddingLeft: isMobile ? 0 : 12,
              margin: 0,
            }}><b>Free Mobile App to keep track of your rows while knitting</b><br />
              Follow several knitting projects, Row Counter with multiple counters, <br />
              Import your pattern in the app, Connect to Ravelry, Knitting/Crochet tools...<br />
            </p>

          </View>
          <View
            style={{
              flexDirection: "column",
              marginTop: isMobile ? 12 : 0,
            }} >
            {
              renderDlBtn(
                "/imgs/android.png",
                "Check on Android",
                "https://play.google.com/store/apps/details?id=com.row_counter"
              )
            }
            {
              renderDlBtn(
                "/imgs/apple.png",
                "Check on iOS",
                "https://apps.apple.com/us/app/my-row-counter-knit-crochet/id1342608792"
              )
            }
          </View>


        </View>
        <p style={{
          color: 'white',
          opacity: 0.8,
          fontSize: 16,
          fontWeight: 'normal',
          fontStyle: "italic",
          letterSpacing: 2,
          padding: 0,
          paddingLeft: 12,
          paddingTop: isMobile ? 12: 0,
          margin: 0,
          marginBottom: 24,
        }}>*Terms and conditions: rowcounterapp.com/giveaway.html</p>

      </ScrollView>

    </ImageBackground>
  );
}

export default GameResult;
